import { useEffect, useState } from "react";
import "@assets/css/map_boundaries/panel.css";
import "@assets/css/mode_tool/panel.css";
import {
  IconArrowLeft,
  IconTrash,
  IconDeviceFloppy,
} from "@tabler/icons-react";

function MapBoundariesPanel({
  isOpen,
  tourName,
  points = [],
  onAutoDrawBoundary,
  onSave,
  onRemovePoint,
  onClose,
}) {
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    if (!Array.isArray(points) || !points.length) return;
    onAutoDrawBoundary?.(points);
  }, [isOpen, onAutoDrawBoundary, points]);

  if (!isOpen) return null;

  return (
    <aside
      className="mode-route-tool-overlay map-boundaries-tool-overlay"
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      onDoubleClick={(event) => event.stopPropagation()}
    >
      <div className="mode-route-tool-header">
        <div className="mode-route-tool-head">
          <button
            type="button"
            className="app-icon-btn app-icon-btn--back"
            aria-label="Go back"
            title="Go back"
            onClick={onClose}
          >
            <IconArrowLeft size={16} />
          </button>
          <div className="map-boundaries-tool-head-spacer" />
          <h3 className="mode-route-tool-title">
            Map Boundaries
            <p className="mode-route-tool-subtitle">
              {tourName || "Selected tour"}
            </p>
          </h3>
        </div>
      </div>

      <div className="map-boundaries-tool-content">
        <p className="map-boundaries-tool-help">
          Select points on the map to create a polygon and delimit the area.
        </p>

        <div className="mode-route-tool-points map-boundaries-tool-points">
          <p className="map-boundaries-tool-points-title">
            Points ({points.length})
          </p>
          {!points.length ? (
            <p className="map-boundaries-tool-help">No points selected yet.</p>
          ) : (
            <div className="mode-route-tool-point-list map-boundaries-tool-points-list">
              {points.map((point, index) => (
                <div
                  key={point?.id || `boundary-${index + 1}`}
                  className="mode-route-tool-point-accordion map-boundaries-tool-point-card"
                >
                  <div className="mode-route-tool-point-item">
                    <div className="mode-route-tool-point-toggle map-boundaries-tool-point-toggle">
                      <span className="mode-route-tool-point-title">
                        <span>Point #{index + 1}</span>
                        <small className="map-boundaries-tool-point-badge-label">
                          {Number(point?.lat || 0).toFixed(6)},{" "}
                          {Number(point?.lng || 0).toFixed(6)}
                        </small>
                      </span>
                    </div>
                    <button
                      type="button"
                      className="app-icon-btn app-icon-btn--delete"
                      aria-label={`Delete boundary point ${index + 1}`}
                      title={`Delete boundary point ${index + 1}`}
                      onClick={() => onRemovePoint?.(point?.id)}
                    >
                      <IconTrash size={14} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="mode-route-tool-steps">
        <button
          type="button"
          className={`app-icon-btn app-icon-btn--add mode-route-tool-route-btn ${isSaving ? "is-loading" : ""}`}
          onClick={async () => {
            if (isSaving || typeof onSave !== "function") return;
            setIsSaving(true);
            try {
              await onSave();
            } finally {
              setIsSaving(false);
            }
          }}
          aria-label={isSaving ? "Saving boundary" : "Save boundary"}
          title={isSaving ? "Saving boundary" : "Save boundary"}
          disabled={isSaving || typeof onSave !== "function"}
        >
          {isSaving ? (
            <span className="mode-route-tool-btn-spinner" />
          ) : (
            <>
              Save
              <IconDeviceFloppy size={14} />
            </>
          )}
        </button>
      </div>
    </aside>
  );
}

export default MapBoundariesPanel;
